import { LoginForm } from "../../components";

import "./loginPage.scss";

const LoginPage = () => {
    return (
        <div className={"login-page"}>
            <LoginForm />
        </div>
    );
};

export { LoginPage };
